import { get } from 'lodash';

import { customAttributesInitialValues } from 'hb-react/shared/components/formik/utils/customAttributes';
import getCsrfToken from 'helpers/getCsrfToken';

export const getInitialValues = ({
  order,
  campaign,
  paymentGateway,
  initialAmount,
  initialFundId,
  initialMonthlyRecurring,
  externalId,
  promotionCode,
}) => {
  const gifts = getGifts({
    initialFundId,
    initialAmount,
    funds: get(campaign, ['funds'], []),
  });
  const monthlyRecurring = getInitialMonthlyRecurring({
    initialMonthlyRecurring,
    campaign,
  });

  return {
    authenticity_token: getCsrfToken(),
    transaction_token: '',
    campaign_id: campaign.id,
    gateway: paymentGateway,
    donation_order: {
      external_id: externalId,
      promotion_code: promotionCode,
      in_honor_of: false,
      in_memory_of: false,
      dedication_title: '',
      dedication_description: '',
      hep_company_id: '',
      monthly_payment: monthlyRecurring ? 'true' : 'false',
      recurring_payment_enabled: monthlyRecurring ? 'true' : 'false',
      lifelong_payment_enabled: 'true',
      recurring_payments_left: 2,
      periodicity: monthlyRecurring ? 'month' : 'three_months',
      tax_number: '',
      amount: initialAmount || '',
      email: order.email || '',
      firstname: order.firstname || '',
      prefix_name: order.prefix_name || '',
      lastname: order.lastname || '',
      maidenname: order.maidenname || '',
      mobile_perso: order.mobile_perso || '',
      mobile_pro: order.mobile_pro || '',
      billing_address_attributes: {
        address_1: order.billing_address.address_1 || '',
        address_2: order.billing_address.address_2 || '',
        address_3: order.billing_address.address_3 || '',
        city: order.billing_address.city || '',
        postal_code: order.billing_address.postal_code || '',
        state: order.billing_address.state || '',
        country: order.billing_address.country || '',
      },
      gifts_attributes: gifts,
      ...customAttributesInitialValues(campaign.customizable_attributes),
      ...customAttributesInitialValues(
        get(order, ['meta', 'user_custom_attributes']),
      ),
    },
  };
};

const getGifts = ({ initialFundId, initialAmount, funds }) => {
  let initialFund;

  if (funds.length === 1) {
    initialFund = funds[0]; // eslint-disable-line prefer-destructuring
  } else if (initialFundId) {
    initialFund = funds.find((fund) => fund.id == initialFundId); // eslint-disable-line eqeqeq
  }

  return initialFund
    ? [
        {
          fund_id: initialFund.id,
          amount: initialAmount || '',
          title: initialFund.title,
          payment_account_external_account_id:
            initialFund.payment_account_external_account_id,
        },
      ]
    : [];
};

const getInitialMonthlyRecurring = ({ initialMonthlyRecurring, campaign }) => {
  if (
    initialMonthlyRecurring &&
    get(campaign, 'recurring_mode') === 'simple_recurring'
  ) {
    return true;
  }

  return false;
};
